import {
  HouseExtension,
  ProductRowDetail,
  ProductRowDetailValue,
  ProductRowDetailValueInline,
} from "./styled";

import { StyledRow } from "App/global-style";
import { useTexts } from "Components/TextContext";
import React from "react";
import { ProductDetail } from "../interface";

interface Props {
  readonly detail: ProductDetail;
}

export const ProductDetailsTableRowDitto = ({
  detail,
}: Props): React.ReactElement | null => {
  const { getText } = useTexts();

  if (!detail.hidden) {
    if (
      detail.name === getText("houseform.shorttitle.additionalbuildings") &&
      typeof detail.value === "object"
    ) {
      return (
        <HouseExtension>
          <p>{detail.name}</p>
          <ProductRowDetailValueInline>
            {detail.value}
          </ProductRowDetailValueInline>
        </HouseExtension>
      );
    }

    return (
      <StyledRow>
        <ProductRowDetail>
          <p>{detail.name}</p>
        </ProductRowDetail>
        <ProductRowDetailValue>{detail.value}</ProductRowDetailValue>
      </StyledRow>
    );
  }
  return null;
};
